import React, { Component } from 'react';
import { LineChart, Line, AreaChart, Area, BarChart, Bar, Legend, Tooltip, CartesianGrid, XAxis, YAxis } from 'recharts';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class BasicLine extends Component {


    constructor(props) {
        super(props);
        this.state = {
            stateData: null
        };
        // this.getStageData();
        console.log(this.props.data);
        this.state.stateData = this.props.data;
    }

    // getStageData(){
    //     fetch('http://api.esj.gg/stage.php').then(function(response){
    //         return response.json();
    //     }).then(function(results){
    //         this.setState({stateData: results});
    //         console.log(this.state);
    //     }.bind(this));
    // }


    // setUserData = () => {
    //   this.props.dispatch({
    //       type: 'SET_USER_DATA',
    //       user: {
    //           "name": "joseph",
    //           "id": 12312312323
    //       }
    //   });
    // };

    increment = () => {
        this.props.dispatch({ type: 'INCREMENT'});
    };

    decrement = () => {
        this.props.dispatch({ type: 'DECREMENT' });
    };

    render() {

        const numbers = [1, 2, 3, 4, 5];
        const listItems = numbers.map((number) =>
            <li key={number}>{number}</li>
        );

        if (this.state.stateData == null){
            return (
                <div>
                    loading...
                </div>
            );
        } else {
            return (
                <div>
                    <h2>Counter</h2>
                    <Link to='/schedule/123123'>Numbered Param</Link>
                    <div>
                        <button onClick={this.setUserData}>Set User Data</button>
                        <button onClick={this.decrement}>-</button>
                       {this.props.count}
                        <button onClick={this.increment}>+</button>
                    </div>

                    <LineChart width={730} height={250} data={this.props.data}>
                        <Line type='monotone' dataKey='amt' stroke='#8884d8' strokeWidth={2} />
                    </LineChart>

                    <AreaChart width={730} height={250} data={this.props.data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                        <Area type="monotone" dataKey="amt" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
                        <defs>
                            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#82ca9d" stopOpacity={0.4}/>
                                <stop offset="80%" stopColor="#82ca9d" stopOpacity={0}/>
                            </linearGradient>
                        </defs>
                        <Legend />
                    </AreaChart>

                    <BarChart width={730} height={250} data={this.props.data} margin={{top: 50}} >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Bar dataKey="pv" fill="#8884d8" />
                    </BarChart>

                    <ul>{listItems}</ul>
                </div>
            );
        }


    }
}

function mapStateToProps(state) {
    return {
        count: state.count
    };
}

export default connect(mapStateToProps)(BasicLine);


// WEBPACK FOOTER //
// ./src/components/shared/BasicLine.js